export default __webpack_public_path__ + "static/badgeRed-87c0316d98cee100e0f051d0ffe66f81.svg";